/**
 * @generated SignedSource<<fcf6105c5841f62024ec32ef27b0c127>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneIssuesListInternal$data = {
  readonly id: string;
  readonly number: number;
  readonly updatedAt: string;
  readonly " $fragmentType": "MilestoneIssuesListInternal";
};
export type MilestoneIssuesListInternal$key = {
  readonly " $data"?: MilestoneIssuesListInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneIssuesListInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneIssuesListInternal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "5b77dc94c1566f48b95f6d89da4a3fc8";

export default node;
